import React from 'react';
import PropTypes from 'prop-types';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import { GridTile } from 'material-ui/GridList';
import NumberFormat from 'react-number-format';

import {
    Grid,
    ItemInformacoesInscricao,
} from '../../components';
import {
    projetoService,
    criterioService,
    Utils,
    loginService,
} from '../../services';
import PrincipalMaster from '../master/Principal';
import arquivoService from '../../services/ArquivoService';
import avaliacaoService from '../../services/AvaliacaoService';

class AvaliarProjeto extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            dsCriterios: [],
            titulo: '',
            media: 0,
            arquivo: '',
            nomeEvento: '',
            nomeSubevento: '',
            nomeCategoria: '',
            nomeArea: '',
            nomeEixo: '',
            nomepessoalogada: '',
        };
    }

    async componentWillMount() {
        const projeto = await projetoService.getProjeto(this.props.match.params.projeto);
        const nome = await loginService.getNome();

        this.setState({
            titulo: projeto.TITULO,
            instituicao: projeto.INSTITUICAO,
            nomeEvento: projeto.NOMEEVENTO,
            nomeSubevento: projeto.NOMESUBEVENTO,
            nomeCategoria: projeto.NOMECATEGORIA,
            nomeArea: projeto.NOMEAREA,
            nomeEixo: projeto.NOMEEIXO,
            arquivo: await arquivoService.getLinkArquivo(this.props.match.params.projeto),
            dsCriterios: await criterioService.getCriterios(this.props.match.params.projeto),
            nomepessoalogada: nome,
        });

        this.getMedia();
    }

    async onSalvarNotas(event) {
        event.preventDefault();

        // Validar se as notas estão entre 0 e 10.
        for (let i = 0; i < this.state.dsCriterios.length; i += 1) {
            const nota = this.state.dsCriterios[i].NOTA;
            if (!nota || parseFloat(nota) < 0 || parseFloat(nota) > 10) {
                Utils.showToast('Há notas inválidas ou obrigatórias.');
                return;
            }
        }

        try {
            const response = await avaliacaoService.save(this.state.dsCriterios, this.props.match.params.projeto);
            this.getMedia();
            Utils.showToast(response.message);
        } catch (error) {
            Utils.showToast(error.message);
        }
    }

    async getMedia() {
        const temMedia = await avaliacaoService.getMediaAvaliador(this.props.match.params.projeto);
        if (temMedia.length > 0 && temMedia[0].MEDIA) {
            this.setState({ media: temMedia[0].MEDIA });
        }
    }

    setNota(event, index) {
        const nota = event.target.value;
        const { dsCriterios } = this.state;
        dsCriterios[index].NOTA = nota;
        dsCriterios[index].PRECISAJUSTIFICAR = nota < 6;
        this.setState({ dsCriterios });
    }

    setJustificativa(event, index) {
        const { dsCriterios } = this.state;
        dsCriterios[index].JUSTIFICATIVA = event.target.value;
        this.setState({ dsCriterios });
    }

    validaNota(nota) {
        let mensagem;
        if (!nota) {
            mensagem = 'Nota obrigatória';
        } else if (parseFloat(nota) < 0 || parseFloat(nota) > 10) {
            mensagem = 'Nota de 0 e 10';
        }
        return mensagem;
    }

    validaJustificativa(item) {
        if (item.PRECISAJUSTIFICAR && !item.JUSTIFICATIVA) {
            return 'Justifique sua nota';
        }
        return '';
    }

    render() {
        const {
            titulo,
            instituicao,
            dsCriterios,
            media,
            nomeEvento,
            nomeSubevento,
            nomeCategoria,
            nomeArea,
            nomeEixo,
            arquivo,
            nomepessoalogada,
        } = this.state;

        return (
            <PrincipalMaster title="Avaliar Resumos/Projetos" {...this.props}>
                <div className="padding-content">
                    <div>
                        <div style={{ marginTop: 16, textAlign: 'center' }}>
                            <ItemInformacoesInscricao texto={nomeEvento} cor="#DE1F1FCC" />
                            <ItemInformacoesInscricao texto={nomeSubevento} cor="#4F805B" />
                            <ItemInformacoesInscricao texto={nomeCategoria} cor="#F37B26" />
                            <ItemInformacoesInscricao texto={nomeArea} cor="#555" />
                            <ItemInformacoesInscricao texto={nomeEixo} cor="#42B1EF" />
                        </div>
                        <div style={{ textAlign: 'center' }}>
                            <h2>{titulo}</h2>  <h4>{instituicao}</h4>
                        </div>
                    </div>

                    <GridTile cols={3} style={{ height: 700, paddingBottom: 48 }}>
                        <iframe style={{ marginTop: 16 }} src={arquivo} height={700} width="100%" title="Arquivo enviado" frameBorder="0" />
                    </GridTile>

                    <form onSubmit={event => this.onSalvarNotas(event)}>
                        <Grid
                            ref={(ref) => { this.criteriosGridRef = ref; }}
                            stripedRows="false"
                            textTableEmpty="Nenhum critério encontrado para este evento."
                            dataSource={dsCriterios}
                            columnSortDefault={0}
                            showSearch={false}
                            columns={[
                                {
                                    text: '', name: 'ORDEM', allowSort: false, allowSearch: false, searchOperator: 'LIKE', width: '5%',
                                },
                                {
                                    text: 'Critério', name: 'NOME', allowSort: false, allowSearch: false, searchOperator: 'LIKE', width: '20%',
                                },
                                {
                                    text: 'Descrição', name: 'DESCRICAO', allowSort: false, allowSearch: false, searchOperator: 'LIKE', width: '25%',
                                },
                                {
                                    text: 'Nota (0.0)',
                                    width: '10%',
                                    name: (item, index) => (
                                        <NumberFormat
                                            placeholder="0.0"
                                            style={{ border: 'dotted 0px #ccc' }}
                                            customInput={TextField}
                                            name={`nota-${index}`}
                                            decimalSeparator=","
                                            thousandSeparator="."
                                            fixedDecimalScale
                                            value={item.NOTA || ''}
                                            onChange={e => this.setNota(e, index)}
                                            errorText={this.validaNota(item.NOTA)}
                                            required
                                        />
                                    ),
                                },
                                {
                                    text: 'Justificativa quando nota menor que 6.0',
                                    width: '50%',
                                    name: (item, index) => (
                                        <TextField
                                            placeholder="Justificativa"
                                            style={{ width: 800 }}
                                            name={`justificativa-${index}`}
                                            value={item.JUSTIFICATIVA || ''}
                                            onChange={e => this.setJustificativa(e, index)}
                                            rows={1}
                                            required={item.PRECISAJUSTIFICAR}
                                            errorText={this.validaJustificativa(item)}
                                        />
                                    ),
                                },
                            ]}
                        />

                        <div style={{ textAlign: 'right' }} >
                            <h5>As notas serão salvas em nome de {nomepessoalogada}</h5>
                            <RaisedButton
                                label="Salvar notas"
                                primary
                                type="submit"
                            />
                            <h3>A média da sua avaliação é: {media}</h3>
                        </div>
                    </form>
                </div>
            </PrincipalMaster>
        );
    }
}

AvaliarProjeto.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            projeto: PropTypes.string,
        }),
    }).isRequired,
    history: PropTypes.shape({
        push: PropTypes.func.isRequired,
    }).isRequired,
};

export default AvaliarProjeto;
